module.exports = __webpack_public_path__ + "img/settings.0b29ef3d.svg";